export default __webpack_public_path__ + "static/media/027-space station.be161e11.svg";